import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsForward20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSkip5SecondsForward20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.063 3.799a.83.83 0 0 0-1.103 0 .68.68 0 0 0 0 1.016L8.247 6H5.25A3.25 3.25 0 0 0 2 9.25v4.5A3.25 3.25 0 0 0 5.25 17H9a.75.75 0 0 0 0-1.5H5.25a1.75 1.75 0 0 1-1.75-1.75v-4.5c0-.966.784-1.75 1.75-1.75h2.997L6.96 8.685a.68.68 0 0 0 0 1.016.83.83 0 0 0 1.103 0l2.653-2.443a.68.68 0 0 0 0-1.016zm7.273 8.451c.675 0 1.122-.49 1.126-.984.004-.573-.396-.971-.813-.971-.507 0-.87.116-1.093.22a1.6 1.6 0 0 0-.283.165l-.002.002a.75.75 0 0 1-1.248-.561V6.5h3.563a.75.75 0 0 1 0 1.5h-2.063v.937a4.3 4.3 0 0 1 1.126-.143c1.457 0 2.322 1.3 2.313 2.484-.012 1.415-1.23 2.471-2.626 2.471a3.2 3.2 0 0 1-1.482-.374 3.3 3.3 0 0 1-.568-.381l-.013-.011-.004-.005-.002-.002h-.001s-.001-.001.507-.553l-.508.552a.75.75 0 0 1 1.01-1.109l.006.005.05.038a1.7 1.7 0 0 0 1.006.34"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsForward20);
